var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-copyright")]),_vm._v(" 2023 — "),_c('strong',[_vm._v("ID-ASN")]),_vm._v(" — v"+_vm._s(_vm.appVersion)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }